<div class="page-heading d-flex justify-content-center">
  EXPLORE YOUR FAVOURITE HIMALAYAN GETAWAYS
</div>

<div class="our-properties d-flex justify-content-center">Our Properties</div>

<div class="mt-4 mb-5 px-4 w-100 sticky-top hotel-tabs-sticky custom-tab-space">
  <div class="tabs-wrapper">
    <app-tab
      [tabs]="tabs"
      [hScroll]="false"
      [vScroll]="false"
      (tabSelected)="onTabChange($event)"
      class="w-100"
      [selectedIndex]="selectedIndex"
    >
    </app-tab>
  </div>
</div>

<div #dynamicGallery style="display: none"></div>

@for (hotel of filteredHotels; track hotel._id; let i = $index) {
  <div class="room-row hotel-card mb-4">
    <div class="left" style="position: relative">
      <div
        class="click-area"
        (click)="goToAvailability(hotel)"
        style="position: absolute; inset: 0; z-index: 1"
      ></div>

      <img
        class="hero"
        [src]="hotel?.galleryInfo?.[0]?.cdnUrl"
        [alt]="hotel?.name"
        style="position: relative; z-index: 2"
        (click)="openHotelGallery(hotel, 0, $event)"
        (keydown.enter)="openHotelGallery(hotel, 0, $event)"
        tabindex="0"
      />

      <div class="thumbs" style="position: relative; z-index: 2">
        @for (t of hotel.galleryInfo?.slice(1, 4); track t; let ti = $index) {
          @if (ti === 2 && hasMoreImages(hotel)) {
            <div
              class="thumb-wrap"
              (click)="openHotelGallery(hotel, ti + 1, $event)"
              (keydown.enter)="openHotelGallery(hotel, ti + 1, $event)"
              tabindex="0"
            >
              <img
                class="thumb"
                [src]="t?.cdnUrl"
                [alt]="hotel?.name + ' thumb'"
              />
              <div class="thumb-overlay">
                <span class="thumb-overlay-count"
                  >+{{ getRemainingImageCount(hotel) }}</span
                >
                <span class="thumb-overlay-text">More</span>
              </div>
            </div>
          } @else {
            <img
              class="thumb"
              [src]="t?.cdnUrl"
              [alt]="hotel?.name + ' thumb'"
              (click)="openHotelGallery(hotel, ti + 1, $event)"
              (keydown.enter)="openHotelGallery(hotel, ti + 1, $event)"
              tabindex="0"
            />
          }
        }
      </div>

      <div class="status-row" style="position: relative; z-index: 2">
        <div class="viewed-row">
          <i class="fa-regular fa-eye"></i>
          <span class="label">Viewed:</span>
          <span class="value">{{ formatCount(hotel?.viewCount) }}</span>
        </div>

        <div class="booked-pill">
          <img
            class="check"
            src="/assets/images/check-icon.svg"
            alt="check-icon"
            width="15"
          />
          <span class="label">Booked By:</span>
          <span class="value">{{ formatCount(hotel?.bookedCount) }}</span>
        </div>
      </div>
    </div>

    <div class="middle">
      <h5 class="hotel-name">{{ hotel?.name }}</h5>
      <p class="hotel-desc">
        <span [innerHTML]="getHotelDescriptionHtml(hotel)"></span>

        <span
          *ngIf="shouldShowReadMore(hotel?.description)"
          class="inline-toggle"
          (click)="onReadMoreClick(hotel, $event)"
        >
          {{
            isMobile
              ? isDescExpanded(hotel?._id)
                ? " Read Less"
                : "... Read More"
              : "... Read More"
          }}
        </span>
      </p>

      <div class="offers">
        <h6 class="offers-title">WE OFFER</h6>

        <div class="offers-grid" [class.mobile-grid]="isMobile">
          @for (offer of getVisibleAmenitiesForCard(hotel); track offer) {
            <span class="offer">
              <img
                class="check"
                src="/assets/images/check-icon.svg"
                alt="check-icon"
              />
              {{ offer?.name }}
            </span>
          }

          @if (shouldShowAmenitiesToggle(hotel)) {
            <div
              class="view-more-amenities"
              (click)="onAmenitiesViewMoreClick(hotel, $event)"
              tabindex="0"
              (keydown.enter)="onAmenitiesViewMoreClick(hotel, $event)"
            >
              {{
                isMobile
                  ? isAmenitiesExpanded(hotel?._id)
                    ? "View Less"
                    : "View More"
                  : "View More"
              }}
              <i
                class="fa-solid fa-chevron-down"
                [ngClass]="[
                  isMobile ? 'mt-0' : 'mt-1',
                  isMobile && isAmenitiesExpanded(hotel?._id) ? 'rotate' : '',
                ]"
              >
              </i>
            </div>
          }
        </div>

        <div class="divider"></div>
      </div>
      <div class="cta">
        <button class="btn-cta" type="button" (click)="viewFactsheet(hotel)">
          Quick Details <i class="fa-solid fa-arrow-right"></i>
        </button>

        <!--
          ✅ CHANGE: routerLink now uses getHotelRouteSegments() which produces
          ['/our-hotels', '<destination-slug>', '<hotel-slug>']
          e.g. /our-hotels/darjeeling/udaan-nirvana-resort-...
        -->
        <button
          class="btn-cta primary availability"
          [routerLink]="getHotelRouteSegments(hotel)"
          [attr.href]="getHotelHref(hotel)"
          [attr.aria-label]="
            'Check availability for ' + (hotel?.name || 'hotel')
          "
        >
          Check Availability
          <i class="fa-solid fa-arrow-right"></i>
        </button>
      </div>
    </div>
  </div>
}

<ng-template #loaderTpl>
  <span class="btn-loader"></span>
</ng-template>
<app-scroll-to-top></app-scroll-to-top>
